import { render } from "./ErrorMessage.vue?vue&type=template&id=bed4f550&scoped=true"
import script from "./ErrorMessage.vue?vue&type=script&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&lang=js"

import "./ErrorMessage.vue?vue&type=style&index=0&id=bed4f550&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bed4f550"

export default script